import React, { useState } from 'react';
import { useTheme } from '../../../context/ThemeContext';
import CustomCard from './CustomCard';

/**
 * Displays scanner information with image, name, description, and stock count
 */
const StockInfoCard = ({ screener, stockCount }) => {
  const { theme } = useTheme();
  const [showFullDescription, setShowFullDescription] = useState(false);

  if (!screener) return null;

  // Handle description being an object or string
  const description = typeof screener.description === 'object'
    ? (screener.description?.display || screener.description?.value || '')
    : (screener.description || '');

  const shouldTruncate = description.length > 150;
  const displayDescription = showFullDescription || !shouldTruncate
    ? description
    : `${description.substring(0, 150)}...`;

  return (
    <CustomCard className="mb-4">
      <div className="flex items-start gap-4">
        {/* Scanner Icon/Image */}
        {screener.image && (
          <div className="flex-shrink-0">
            <img
              src={screener.image}
              alt={screener.name}
              className="w-16 h-16 rounded-[6px] object-cover"
              style={{
                boxShadow: theme === 'dark'
                  ? '0px 2px 5px 1px rgba(175, 175, 175, 0.1)'
                  : '0px 2px 5px 1px rgba(87, 87, 87, 0.1)'
              }}
            />
          </div>
        )}

        {/* Scanner Info */}
        <div className="flex-grow">
          <h3 className={`text-base font-semibold mb-1 text-p300`}>
            {typeof screener.name === 'object'
              ? (screener.name?.display || screener.name?.value || 'Unknown')
              : (screener.name || 'Unknown')}
          </h3>

          <p className={`text-[13px] font-normal mb-1 text-n600`}>
            {displayDescription}
            {shouldTruncate && (
              <button
                onClick={() => setShowFullDescription(!showFullDescription)}
                className={`ml-1 text-sm font-medium ${theme === 'dark' ? 'text-[#0055DD]' : 'text-[#0075FF]'}`}
              >
                {showFullDescription ? 'Less...' : 'More...'}
              </button>
            )}
          </p>

          {/* Stock Count */}
          <div className="mt-2">
            <span className={`text-sm font-medium ${theme === 'dark' ? 'text-[#7F7F7F]' : 'text-[#878787]'}`}>
              {stockCount || 0} Stocks Found
            </span>
          </div>
        </div>
      </div>
    </CustomCard>
  );
};

export default StockInfoCard;
